import { SIZE_SELECT_ERROR } from "../../constants";
import { ERROR } from "../../../common/constants";

export const showSizeSelectPrompt = payload => dispatch => {
  dispatch({ type: SIZE_SELECT_ERROR, payload });
  dispatch({ type: ERROR, payload: { failedActionType: SIZE_SELECT_ERROR } });
};
